"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionScoreClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class SessionScoreClient extends authenticated_client_1.AuthenticatedClient {
    csvExport(projectId, payload, fileName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const uri = `/v1/projects/${projectId}/session-score/export`;
            const response = yield this.executeRaw('post', uri, payload);
            return {
                buffer: response.data,
                filename: fileName,
                contentType: response.headers['content-type'],
            };
        });
    }
}
exports.SessionScoreClient = SessionScoreClient;
//# sourceMappingURL=session-score.client.js.map